/** @jsxRuntime classic */
/** @jsx jsx */
import { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/react';

import { store, SNACKBAR } from '../store';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

export default function SnackBar() {
  const [open, setOpen] = useState(false);
  const [snacks, setSnacks] = useState([]);

  useEffect(() => {
    let timeout;
    store[SNACKBAR].subscribe((snack) => {
      if (!snack) return;
      setSnacks(snack);
      setOpen(true);

      if (timeout) {
        clearTimeout(timeout);
      }
    });
  }, []);

  if (false && !snacks.length) {
    return null;
  }

  return (
    <div>
      {snacks?.map(({ msg, variant, duration }) => (
        <Snackbar
          open={open}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          autoHideDuration={duration || 3000}
          onClose={() => setOpen(false)}
          key={msg}
          css={css`
            z-index: 99999;
          `}
        >
          <MuiAlert
            severity={variant}
            css={css`
              width: 20rem;
            `}
          >
            {msg}
          </MuiAlert>
        </Snackbar>
      ))}
    </div>
  );
}
